import { silderStore } from '@/store/silderBar';
import { RouteRecordRaw } from 'vue-router';
import { Local } from '@/utils/storage';

/**
 * 根据管理员权限生成动态路由
 * @param permissionCodes 管理员拥有的权限标识数组
 * @returns 过滤后的路由数组
 */
export function generateDynamicRoutes(permissionCodes: string[]): RouteRecordRaw[] {
    const store = silderStore();
    
    // 使用静态路由作为基础
    const allRoutes = [...store.routers];
    
    // 根据权限过滤路由
    const filteredRoutes = store.filterRoutersByPermission(allRoutes, permissionCodes);
    
    return filteredRoutes;
}

/**
 * 初始化动态路由
 * 在登录后调用，根据管理员权限设置侧边栏菜单
 */
export function initDynamicRoutes() {
    let permissionCodes = Local.get('permissionCodes');
    const store = silderStore();

    
    // 如果没有传入权限码，尝试从缓存获取
    if (!permissionCodes) {
        store.initRouters();
        return;
    }


    const dynamicRoutes = generateDynamicRoutes(permissionCodes!);
    store.setDynamicRouters(dynamicRoutes);
    
    // 缓存路由到本地
    Local.set('dynamicRouters', store.routers);
    Local.set('permissions', permissionCodes);
}

/**
 * 清除动态路由
 * 在退出登录时调用
 */
export function clearDynamicRoutes() {
    const store = silderStore();
    Local.remove('dynamicRouters');
    Local.remove('permissions');
    store.initRouters();
}

/**
 * 检查是否有某个权限
 * @param permissionCode 权限标识
 * @returns 是否有该权限
 */
export function hasPermission(permissionCode: string): boolean {
    const permissions = Local.get('permissionCodes') || [];
    if(permissions[0] == 'all'){
        return true;
    }

    return permissions.includes(permissionCode);
}

/**
 * 检查是否有某些权限（满足任一即可）
 * @param permissionCodes 权限标识数组
 * @returns 是否有权限
 */
export function hasAnyPermission(permissionCodes: string[]): boolean {
    return permissionCodes.some(code => hasPermission(code));
}

/**
 * 检查是否有所有权限（必须全部满足）
 * @param permissionCodes 权限标识数组
 * @returns 是否有所有权限
 */
export function hasAllPermissions(permissionCodes: string[]): boolean {
    return permissionCodes.every(code => hasPermission(code));
}
